import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Description {
  id: number;
  name: string;
}

interface TimePeriod {
  id: number;
  value: string;
  name: string;
}


interface ImportDataState {
  participantId: number;
  listingPageType: string;
  rowData: any[];
  isInitialRender: boolean;
  quarter: TimePeriod | null;
  period: TimePeriod | null;
  semiannually: TimePeriod | null;
  month: TimePeriod | null;
  yearlyType: TimePeriod | null;
  year: string;
  selectSheet: string;
  amountColumn: string;
  amounts: Record<string, string>;
  descriptionColumn: Description[];
  selectedFile: string;
  sheets: any[];
  descriptionColumnList: any[];
  amountColumnList: any[];
  transformedImport: any[];
  forecastMappingDetails: any[];
  filteredMonthsList: any[];
  fileColumnMappingDetailes: any;
}

const initialState: ImportDataState = {
  participantId: 0,
  listingPageType: "",
  rowData: [],
  isInitialRender: false,
  quarter: null,
  period: null,
  semiannually: null,
  month: null,
  yearlyType: null,
  year: "",
  selectSheet: "",
  amountColumn: "",
  amounts: {},
  descriptionColumn: [],
  selectedFile: "",
  sheets: [],
  descriptionColumnList: [],
  amountColumnList: [],
  transformedImport: [],
  forecastMappingDetails: [],
  filteredMonthsList: [],
  fileColumnMappingDetailes: [], 
};

const importDataSlice = createSlice({
  name: 'importData',
  initialState,
  reducers: {
    setImportDataDetails: (state, action: PayloadAction<Partial<ImportDataState>>) => {
      return { ...state, ...action.payload };
    },
    resetImportDataDetails: () => initialState,
    setImportDataError: (state, action: PayloadAction<string>) => {
    },
  },
});

export const { setImportDataDetails, resetImportDataDetails, setImportDataError } = importDataSlice.actions;
export default importDataSlice.reducer;
